
import { useEffect, useMemo, useState } from 'react';
import styles from './PcAccess.module.scss';
import { RestS } from '../../../rest/rest-service';
import { featureType } from '../../../interfaces/interfaces';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import Switch from "react-switch";
import { getLocalUser } from '../../../components/functions/utilities';
import set from 'date-fns/fp/set/index';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { useNavigate } from 'react-router';

type Props = {
    showInModal?: boolean;
    closeForm?: () => void;
}

const PcAccess = ({ showInModal, closeForm }: Props) => {
    const [loading, setLoading] = useState(false);
    const [accessList, setAccessList] = useState([]);
    const currentUser = getLocalUser();
    const [accessChanges, setAccessChanges] = useState({});
    const [saveChangesLoading, setSaveChangesLoading] = useState(false);
    const navigate = useNavigate();

    const getAccessList = async () => {
        try {
            const data: any = await RestS.getAccessListByFeature(featureType.profitabilityCalculator);
            setAccessList(data?.featureAccess);
        } catch (error) {
            console.log('error', error);
        }
    }

    const updateAccess = async (accessIndex: number, access: boolean) => {
        try {
            const oldCopyExistingData = JSON.parse(JSON.stringify(accessList[accessIndex]));
            const existingData = { ...accessList[accessIndex] };
            existingData.access = access;
            const existingAccessList = JSON.parse(JSON.stringify(accessList));
            existingAccessList[accessIndex] = existingData;
            setAccessList(existingAccessList);
            const accessDoc = {
                userId: oldCopyExistingData.userId,
                feature: featureType.profitabilityCalculator,
                access: access,
            }
            setAccessChanges(prev => ({ ...prev, [oldCopyExistingData.userId]: accessDoc }));
            if (!showInModal) {
                const updatedData = await RestS.updateAccessListByFeature(accessDoc)
            }
        } catch (error) {
            if (error?.response?.data) {
                console.log('error', error?.response?.data)
                const message = error?.response?.data?.message;
                if (message == "Unauthorized") {
                    navigate('/pnltracker')
                }
            }
            const existingAccess = JSON.parse(JSON.stringify(accessList));
            existingAccess[accessIndex] = accessList[accessIndex];
            setAccessList(existingAccess);
            console.log('error', error);
        }
    }

    useEffect(() => {
        (async () => {
            setLoading(true);
            await getAccessList();
            setLoading(false);
        })()
    }, []);

    const saveChanges = async () => {
        try {
            setSaveChangesLoading(true)
            console.log('accessChanges', accessChanges);
            const bodyData = {
                accessData: Object.values(accessChanges)
            }
            const featureAccess = await RestS.updateBulkFeatureAccess(bodyData);
        } catch (error) {
            console.log('error', error);
            if (error?.response?.data) {
                console.log('error', error?.response?.data)
                const message = error?.response?.data?.message;
                if (message == "Unauthorized") {
                    navigate('/pnltracker')
                }
            }
        } finally {
            setSaveChangesLoading(false)
            closeForm();
        }
    }

    const isSaveChangesDisabled = useMemo(() => {
        if (Object.keys(accessChanges).length) {
            return false;
        } else {
            return true;
        }
    }, [accessChanges])


    return (
        <>
            <div className={`${styles.pcAccessRootContainer} ${showInModal ? styles.rootModal : ''}`}>
                <div className={`${styles.pcAccessWrapper} ${showInModal ? styles.wrapperModal : ''}`}>
                    {loading ? <div className={styles.loaderContainer}>
                        <CircularLoader />
                    </div> :
                        <>
                            {!showInModal ? <div className={styles.accessTitle}>
                                Allow Access to P&L Tracker
                            </div> : null}
                            <div className={styles.accessContainer}>
                                <div className={styles.accessHeader}>
                                    <div className={styles.accessHeaderTitle}>
                                        Name
                                    </div>

                                </div>
                                <div className={styles.accessBody}>
                                    {accessList.map((item, index) => {
                                        return (
                                            <div className={styles.accessListItem}>
                                                <div className={styles.accessListTitleSection}>
                                                    <div className={styles.userName}>
                                                        {item?.name}
                                                    </div>
                                                    <div className={styles.email}>
                                                        {item?.email}
                                                    </div>
                                                </div>

                                                <div className={styles.insightModeToggle}>
                                                    <Switch
                                                        draggable={false}
                                                        disabled={currentUser.id === item.userId}
                                                        checked={item.access}
                                                        onChange={(checked) => {
                                                            // console.log('checked', checked)
                                                            updateAccess(index, checked)
                                                        }}
                                                        onColor="#100828"
                                                        offColor="#D5D5D5"
                                                        handleDiameter={20}
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                                                        activeBoxShadow="0px 0px 1px 1px rgba(0, 0, 0, 0.2)"
                                                        height={24}
                                                        width={43}
                                                        className={styles.switch}
                                                        id="material-switch"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
            {showInModal ? <div className={styles.footerContainer}>
                <MeritoButton btnText='Cancel' type='tertiary' onClick={() => closeForm()} />
                <MeritoButton disabled={isSaveChangesDisabled} btnText='Update Access' type='primary-1' onClick={saveChanges} />
            </div> : null}
        </>


    );
}

export default PcAccess;